import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Input,
  Row,
  Switch,
  Select,
  notification,
  DatePicker,
  Icon,
  message,
  Upload,
} from 'antd'
import Image from './Image'
import Moment from 'moment'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import getDate from 'util/ConfigDates'
import {
  createCouponWithImage, // fetchCoupon
  fetchCouponsData,
} from 'appRedux/actions/Coupons'

const Option = Select.Option

const FormItem = Form.Item

const {TextArea} = Input

class Basic extends React.Component {
  state = {
    visible: false,
    branchOffice: '',
    category: '',
    ticketName: '',
    loading: false,
    description: '',
    loading: false,
    active: 1,
    points: 0,
    creationDay: getDate('dateFrom'),
    expirationDay: getDate('dateFrom'),
    validateStatusBranchOffice: '',
    helpBrachOffice: '',
    validateStatusTicketName: '',
    helpTicketName: '',
    validateStatusCreation: '',
    helpCreation: '',
    validateStatusPoints: '',
    helpPoints: '',
    validateTarea: '',
    helpTarea: '',
    validateCategory: '',
    helpCategory: '',
    dateFrom: getDate('dateFrom'),
    dateTo: getDate('dateTo'),
  }

  arrayC = () => {
    let array = this.props.placeStores
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {decode(element.name)}
        </Option>
      )
    })
  }

  arrayCat = () => {
    let array = this.props.categories
    return array.map((element, index) => {
      return (
        <Option key={index} value={element.id}>
          {decode(element.name)}
        </Option>
      )
    })
  }

  showModal = () => {
    this.setState({
      visible: true,
    })
  }

  handleCancel = e => {
    this.setState({
      description: '',
      active: 1,
      points: 0,
      creationDay: getDate('dateFrom'),
      expirationDay: getDate('dateFrom'),
    })
    this.props.fetchCouponsData(this.state)
    this.setState({visible: false})

    if (this.state.branchOffice == '') {
      this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
    }
    if (this.state.ticketName == '') {
      this.setState({validateStatusTicketName: '', helpTicketName: ''})
    }
    if (this.state.creationDay == '') {
      this.setState({validateStatusCreation: '', helpCreation: ''})
    }
    if (this.state.points == '') {
      this.setState({validateStatusPoints: '', helpPoints: ''})
    }
    if (this.state.category == '') {
      this.setState({validateCategory: '', helpCategory: ''})
    }
    if (this.state.description == '') {
      this.setState({validateTarea: '', helpTarea: ''})
    }
  }

  onChangeS = checked => {
    if (checked) {
      this.setState({active: 1})
    } else {
      this.setState({active: 0})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'El cupón se ha creado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al crear el cupón.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {
      branchOffice,
      ticketName,
      creationDay,
      points,
      category,
      description,
    } = this.state
    if (this.state.validateStatus != 'error') {
      if (
        branchOffice &&
        ticketName &&
        creationDay &&
        points >= 0 &&
        category &&
        description
      ) {
        this.props.createCouponWithImage(this.state, () => {
          this.props.fetchCouponsData(this.state)
        })
        this.setState({
          ticketName: '',
          description: '',
          active: 1,
          points: 0,
          creationDay: getDate('dateFrom'),
          expirationDay: getDate('dateFrom'),
          imageUrl: '',
        })
        this.onNotification('success')
      } else {
        if (this.state.branchOffice == '') {
          this.setState({
            validateStatusBranchOffice: 'error',
            helpBrachOffice: 'Nombre tienda es un campo obligatorio.',
          })
        } else {
          this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
        }
        if (this.state.ticketName == '') {
          this.setState({
            validateStatusTicketName: 'error',
            helpTicketName: 'Nombre oferta es un campo obligatorio.',
          })
        } else {
          this.setState({validateStatusTicketName: '', helpTicketName: ''})
        }
        if (this.state.points === '') {
          this.setState({
            validateStatusPoints: 'error',
            helpPoints: 'Puntos es un valor obligatorio.',
          })
        } else {
          this.setState({validateStatusPoints: '', helpPoints: ''})
        }
        if (this.state.creationDay == '') {
          this.setState({
            validateStatusCreation: 'error',
            helpCreation: 'Fecha creación es un campo obligatorio.',
          })
        } else {
          this.setState({validateStatusCreation: '', helpCreation: ''})
        }
        if (this.state.description == '') {
          this.setState({
            validateTarea: 'error',
            helpTarea: 'Descripción es un campo obligatorio.',
          })
        } else {
          this.setState({validateTarea: '', helpTarea: ''})
        }
        if (this.state.category == '') {
          this.setState({
            validateCategory: 'error',
            helpCategory: 'Categoría es un campo obligatorio.',
          })
        } else {
          this.setState({validateCategory: '', helpCategory: ''})
        }
      }
    } else {
      this.onNotification('error', 'La contraseña de validación es incorrecta.')
    }
  }

  onChangeCalendar = (date, dateString) => {
    this.setState({creationDay: dateString})
    this.setState({
      validateStatusCreation: '',
      helpCreation: '',
    })
  }

  onChangeCalendarExpiration = (date, dateString) => {
    this.setState({expirationDay: dateString})
  }

  handleChangeCombo = value => {
    this.setState({
      branchOffice: value,
    })
    this.setState({validateStatusBranchOffice: '', helpBrachOffice: ''})
  }

  handleChangeCategory = value => {
    this.setState({
      category: value,
    })
    this.setState({validateCategory: '', helpCategory: ''})
  }

  handlChangeImage = selectorFiles => {
    const file = selectorFiles[0]
    this.setState({imageUrl: file})
  }

  render() {
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          Crear cupón
        </Button>
        <Modal
          afterClose={() => this.props.fetchCouponsData(this.state)}
          okText="Crear"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Nuevo cupón">
            <form onSubmit={this.onHandleClick}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Tienda"
                    labelCol={{xs: 12, sm: 8, lg: 8, md: 12}}
                    validateStatus={this.state.validateStatusBranchOffice}
                    help={this.state.helpBrachOffice}
                  >
                    <Select
                      className="gx-mr-3 gx-mb-3"
                      defaultValue="Seleccionar"
                      onChange={this.handleChangeCombo}
                      style={{width: 140}}
                    >
                      {this.arrayC()}
                    </Select>
                  </FormItem>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Nombre oferta *"
                    labelCol={{xs: 14, sm: 14, lg: 14, md: 12}}
                    validateStatus={this.state.validateStatusTicketName}
                    help={this.state.helpTicketName}
                  >
                    <Input
                      required
                      placeholder="Nombre del cupón"
                      value={this.state.ticketName}
                      onChange={event => {
                        this.setState({
                          ticketName: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateStatusTicketName: '',
                            helpTicketName: '',
                          })
                        } else {
                          this.setState({
                            validateStatusTicketName: 'error',
                            helpTicketName:
                              'Nombre de la oferta es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha creación *:"
                    labelCol={{xs: 14, sm: 14, lg: 14, md: 14}}
                    validateStatus={this.state.validateStatusCreation}
                    help={this.state.helpCreation}
                  >
                    <DatePicker
                      defaultValue={Moment(
                        this.state.creationDay,
                        'YYYY-MM-DD',
                      )}
                      className="gx-mb-3 gx-w-100"
                      onChange={this.onChangeCalendar}
                    />
                  </FormItem>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha expiración *:"
                    labelCol={{xs: 14, sm: 14, lg: 14, md: 14}}
                  >
                    <DatePicker
                      defaultValue={Moment(
                        this.state.expirationDay,
                        'YYYY-MM-DD',
                      )}
                      className="gx-mb-3 gx-w-100"
                      onChange={this.onChangeCalendarExpiration}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={24} xs={24}>
                  <FormItem
                    label="Categoría *"
                    labelCol={{xs: 24, sm: 24, lg: 12, md: 12}}
                    validateStatus={this.state.validateCategory}
                    help={this.state.helpCategory}
                  >
                    <Select
                      className="gx-mr-3 gx-mb-3"
                      defaultValue="Seleccionar"
                      onChange={this.handleChangeCategory}
                    >
                      {this.arrayCat()}
                    </Select>
                  </FormItem>
                </Col>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Card type="inner" title="Descripción">
                    <FormItem
                      validateStatus={this.state.validateTarea}
                      help={this.state.helpTarea}
                    >
                      <TextArea
                        rows={4}
                        required
                        placeholder="Datos del cupón"
                        value={this.state.description}
                        onChange={event => {
                          this.setState({
                            description: event.target.value,
                          })
                          if (event.target.value != '') {
                            this.setState({validateTarea: '', helpTarea: ''})
                          } else {
                            this.setState({
                              validateTarea: 'error',
                              helpTarea:
                                'Descripción de la oferta es un campo obligatorio.',
                            })
                          }
                        }}
                      />
                    </FormItem>
                  </Card>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Card type="inner" title="Valor en puntos">
                    <FormItem
                      labelCol={{xs: 9, sm: 9, lg: 9, md: 9}}
                      validateStatus={this.state.validateStatusPoints}
                      help={this.state.helpPoints}
                    >
                      <Input
                        placeholder="Puntos"
                        value={this.state.points}
                        onChange={event => {
                          if (event.target.value >= 0) {
                            this.setState({
                              points: event.target.value,
                            })
                          }
                          if (
                            event.target.value != '' &&
                            event.target.value >= 0
                          ) {
                            this.setState({
                              validateStatusPoints: '',
                              helpPoints: '',
                            })
                          } else {
                            this.setState({
                              validateStatusPoints: 'error',
                              helpPoints:
                                'Puntos (no letras) es un campo obligatorio.',
                            })
                          }
                        }}
                      />
                    </FormItem>
                  </Card>
                </Col>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <Card type="inner" title="Foto del cupón">
                    <FormItem
                      label="Tamaño: (700 x 450 px)"
                      labelCol={{xs: 24, sm: 24, lg: 24, md: 24}}
                    />
                    <input
                      type="file"
                      onChange={event => {
                        this.handlChangeImage(event.target.files)
                      }}
                    />
                  </Card>
                </Col>
              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, categories}) {
  return {
    placeStores,
    categories,
  }
}

export default connect(
  mapStateToProps,
  {createCouponWithImage, fetchCouponsData},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/Modal.js